import Joi from 'joi';

/**
 * Schema for record validation.
 * @description This schema is used to validate the record properties when creating or updating the record.
 */
export const commissionTierItemSchema = () =>
	Joi.object({
		description: Joi.string().allow(null, '').max(256).messages({
			'string.max': 'validations|commission-tier-item-description|max-length',
		}),

		// Commission rate
		rate: Joi.any().required().messages({
			'any.required': 'validations|commission-tier-item-rate|required',
		}),

		pricingItemPresetId: Joi.number().allow(null),
	})
		// Ignore extra fields
		.unknown();
